import React, { useState } from 'react';
import { PlusIcon, XMarkIcon } from '@heroicons/react/24/outline';

export interface FAQItemProps {
  question: string;
  answer: string;
  index: number;
}

export const FAQItem: React.FC<FAQItemProps> = ({ question, answer, index }) => {
  const [isOpen, setIsOpen] = useState(index === 0); // First item open by default

  return (
    <div className="border-b border-tiber-200 last:border-0">
      <div className="w-full py-6 md:py-8 flex items-start gap-4 md:gap-6 text-left group">
        {/* Number */}
        <div className="shrink-0">
          <span className="text-4xl md:text-5xl font-bold text-atlantis-600 leading-none select-none">
            {String(index + 1).padStart(2, '0')}
          </span>
        </div>

        {/* Question and Answer */}
        <div className="flex-1 min-w-0">
          <div className={`flex justify-between gap-4 ${!isOpen ? 'items-center' : 'items-start'}`}>
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="text-left flex-1 pr-4"
            >
              <h3 className="text-lg md:text-xl font-bold text-tiber-900">
                {question}
              </h3>
            </button>
            
            {/* Toggle Button */}
            <button
              className="shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-full bg-tiber-900 text-white flex items-center justify-center transition-all duration-300 hover:scale-110 hover:bg-tiber-950 shadow-md"
              onClick={() => setIsOpen(!isOpen)}
              aria-label={isOpen ? 'Close' : 'Open'}
            >
              {isOpen ? (
                <XMarkIcon className="w-5 h-5 md:w-6 md:h-6 transition-transform duration-300" />
              ) : (
                <PlusIcon className="w-5 h-5 md:w-6 md:h-6 transition-transform duration-300" />
              )}
            </button>
          </div>

          {/* Answer with slide animation */}
          <div
            className={`overflow-hidden transition-all duration-500 ease-in-out ${
              isOpen ? 'max-h-[300px] opacity-100' : 'max-h-0 opacity-0'
            }`}
          >
            <p className="text-tiber-800 text-base font-light leading-relaxed max-w-5xl">
              {answer}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
